import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Modal, Paper, Grid, Typography, withStyles, IconButton, Card, Tooltip, Fab } from '@material-ui/core';
import { ArrowBack, ArrowForward, SettingsBackupRestore } from '@material-ui/icons';
import * as actionsDownload from '../../sc-downloadAll/store/downloadActions';
import * as actions from '../store/mediaActions';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloseIcon from '@material-ui/icons/Close';
import CloudUpload from '@material-ui/icons/CloudUpload';
import ReactPlayer from 'react-player';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import MediaItem from './MediaItem';
import moment from 'moment';
import { downloadFile, createHistory } from '../../sc-utilities';
import { snackActions } from '../../sc-utilities/SnackBar';
import MediaDelete from './MediaDelete';
import { Redirect } from 'react-router-dom';

const styles = (theme) => ({
    root: {
        overflow: 'hidden',
        height: 'auto',
        marginTop: '-13px',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%',
        },
        paddingLeft: 20,
    },
    audioItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '40vw',
        [theme.breakpoints.down('sm')]: {
            width: '60vw',
        },
    },
    audioIcon: {
        position: 'absolute',
        zIndex: 10,
        fontSize: '6em',
    },
    paper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    image: {
        maxHeight: '90vh',
        [theme.breakpoints.down('sm')]: {
            maxHeight: '60vh',
        },
    },
    signature: {
        backgroundColor: '#FFFFFF',
        maxHeight: '90vh',
        [theme.breakpoints.down('sm')]: {
            maxHeight: '60vh',
        },
    },
    iconError: {
        fontSize: '6em',
        color: '#ffffff',
        paddingBottom: '2vh',
    },
    iconNavigation: {
        color: '#ffffff',
    },
    iconActions: {
        color: '#ffffff',
        position: 'absolute',
        top: 0,
        right: 0,
    },
    iconClose: {
        color: '#ffffff',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    textError: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        color: '#ffffff',
    },
    modal: {
        backgroundColor: 'rgba(0, 0, 0, 0.87)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalDiv: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none',
    },
    modalInner: {
        padding: 40,
        [theme.breakpoints.down('sm')]: {
            padding: 10,
        },
    },
    errorContainer: {
        padding: '50px',
    },
    iconErrorContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    gridContainer: {
        paddingRight: 20,
        paddingBottom: 50,
    },
    mediaTitle: {
        padding: 20,
        paddingLeft: 0,
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginTop: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    iconUpload: {
        marginRight: theme.spacing(),
    },
});

const rotationStyle = (rotation) => {
    return {
        transform: `rotate(${rotation}deg) scale(.7)`,
    };
};

function MediaGallery(props) {
    const {
        classes,
        images,
        videos,
        audio,
        refresh,
        signatures,
        entity,
        translations,
        onDownload,
        onDeleteMedia,
        activeCustomerID,
        onRefresh,
        deleting,
        productID,
        orderID,
        transportColliID,
    } = props;
    const [open, setOpen] = useState({
        open: false,
        path: '',
        type: '',
        index: 0,
    });
    const [sortedImages, setSortedImages] = useState([]);
    const [sortedVideos, setSortedVideos] = useState([]);
    const [sortedAudio, setSortedAudio] = useState([]);
    const [sortedSignatures, setSortedSignatures] = useState([]);
    const [rotation, setRotation] = useState(0);
    const [downloading, setDownloading] = useState({});
    const [deleteModalState, setDeleteModalState] = useState({
        open: false,
        mediaId: null,
    });
    const [redirectOptions, setRedirectOptions] = useState({
        redirect: false,
        productID: null,
        orderID: null,
        transportColliID: null,
        redirectPath: '',
    });

    const handleOpen = (path, type, index, id) => {
        setOpen({ open: true, path: path, type: type, index: index, id: id });
    };

    const handleClose = () => {
        setOpen({ open: false, path: '', type: '', index: 0 });
        setRotation(0);
    };

    const goToUploadMedia = () => {
        createHistory();
        let redirectPath = '/media/upload?';
        if (productID) {
            redirectPath += `productID=${productID}`;
        } else if (orderID) {
            redirectPath += `orderID=${orderID}`;
        } else if (transportColliID) {
            redirectPath += `transportColliID=${transportColliID}`;
        }
        setRedirectOptions({
            redirect: true,
            productID,
            orderID,
            transportColliID,
            redirectPath,
        });
    };

    const handleBack = () => {
        setRotation(0);
        switch (open.type) {
            case 'audio':
                return setOpen({
                    open: true,
                    path: sortedAudio[open.index === 0 ? sortedAudio.length - 1 : open.index - 1].path,
                    type: open.type,
                    index: open.index === 0 ? sortedAudio.length - 1 : open.index - 1,
                    id: sortedAudio[open.index === 0 ? sortedAudio.length - 1 : open.index - 1].id,
                });
            case 'video':
                return setOpen({
                    open: true,
                    path: sortedVideos[open.index === 0 ? sortedVideos.length - 1 : open.index - 1].path,
                    type: open.type,
                    index: open.index === 0 ? sortedVideos.length - 1 : open.index - 1,
                    id: sortedVideos[open.index === 0 ? sortedVideos.length - 1 : open.index - 1].id,
                });
            case 'image':
                return setOpen({
                    open: true,
                    path: sortedImages[open.index === 0 ? sortedImages.length - 1 : open.index - 1].path,
                    type: open.type,
                    index: open.index === 0 ? sortedImages.length - 1 : open.index - 1,
                    id: sortedImages[open.index === 0 ? sortedImages.length - 1 : open.index - 1].id,
                });
            case 'signature':
                return setOpen({
                    open: true,
                    path: sortedSignatures[open.index === 0 ? sortedSignatures.length - 1 : open.index - 1].path,
                    type: open.type,
                    index: open.index === 0 ? sortedSignatures.length - 1 : open.index - 1,
                    id: sortedSignatures[open.index === 0 ? sortedSignatures.length - 1 : open.index - 1].id,
                });
            default:
                return null;
        }
    };

    const handleNext = () => {
        setRotation(0);
        switch (open.type) {
            case 'audio':
                return setOpen({
                    open: true,
                    path: sortedAudio[open.index + 1 === sortedAudio.length ? 0 : open.index + 1].path,
                    type: open.type,
                    index: open.index + 1 === sortedAudio.length ? 0 : open.index + 1,
                    id: sortedAudio[open.index + 1 === sortedAudio.length ? 0 : open.index + 1].id,
                });
            case 'video':
                return setOpen({
                    open: true,
                    path: sortedVideos[open.index + 1 === sortedVideos.length ? 0 : open.index + 1].path,
                    type: open.type,
                    index: open.index + 1 === sortedVideos.length ? 0 : open.index + 1,
                    id: sortedVideos[open.index + 1 === sortedVideos.length ? 0 : open.index + 1].id,
                });
            case 'image':
                return setOpen({
                    open: true,
                    path: sortedImages[open.index + 1 === sortedImages.length ? 0 : open.index + 1].path,
                    type: open.type,
                    index: open.index + 1 === sortedImages.length ? 0 : open.index + 1,
                    id: sortedImages[open.index + 1 === sortedImages.length ? 0 : open.index + 1].id,
                });
            case 'signature':
                return setOpen({
                    open: true,
                    path: sortedSignatures[open.index + 1 === sortedSignatures.length ? 0 : open.index + 1].path,
                    type: open.type,
                    index: open.index + 1 === sortedSignatures.length ? 0 : open.index + 1,
                    id: sortedSignatures[open.index + 1 === sortedSignatures.length ? 0 : open.index + 1].id,
                });
            default:
                return null;
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'ArrowRight') {
            handleNext();
        }
        if (event.key === 'ArrowLeft') {
            handleBack();
        }
    };

    useEffect(() => {
        if (images && images instanceof Array) {
            setSortedImages(images.length > 0 ? sortMedia(images) : images);
        }
        if (audio && audio instanceof Array) {
            setSortedAudio(audio.length > 0 ? sortMedia(audio) : audio);
        }
        if (videos && videos instanceof Array) {
            setSortedVideos(videos.length > 0 ? sortMedia(videos) : videos);
        }
        if (signatures && signatures instanceof Array) {
            setSortedSignatures(signatures.length > 0 ? sortMedia(signatures) : signatures);
        }
    }, [images, audio, videos, signatures]);

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const sortMedia = (media) => {
        const sortedMedia = media.sort((a, b) => {
            return (
                moment(b.createdAt, 'DD-MMM-YYYY HH:mm:ss').valueOf() -
                moment(a.createdAt, 'DD-MMM-YYYY HH:mm:ss').valueOf()
            );
        });
        return sortedMedia;
    };

    const rotateRight = () => {
        let newRotation = rotation + 90;
        if (newRotation >= 360) {
            newRotation = -360;
        }
        setRotation(newRotation);
    };

    const rotateLeft = () => {
        let newRotation = rotation - 90;
        if (newRotation >= 360) {
            newRotation = -360;
        }
        setRotation(newRotation);
    };

    const handleReset = (resetTransform) => {
        resetTransform();
        setRotation(0);
    };

    const handleDownload = async (id, path, isSignature = false) => {
        let relativePath = path.split('/');
        const mediaName = relativePath.pop();
        relativePath = relativePath.splice(relativePath.indexOf('static-media') + 1);
        setDownloading({ [path]: true });
        let imageData = await onDownload(relativePath.join('/') + '/' + mediaName, isSignature);
        if (imageData) {
            setDownloading({ [path]: false });
            return downloadFile(imageData, mediaName);
        }
        setDownloading({ [path]: false });
        snackActions.snackBarComponent('Could not find media!', 'error');
    };

    const handleCloseSafe = () => {
        setDeleteModalState({ open: false, mediaId: null });
    };

    const handleCloseDanger = async () => {
        if (!deleteModalState.isSignature) {
            await onDeleteMedia(
                {
                    MediaID: deleteModalState.mediaId,
                    ActiveCustomerID: activeCustomerID,
                },
                false
            );
        } else {
            await onDeleteMedia(
                {
                    SignatureID: deleteModalState.mediaId,
                    ActiveCustomerID: activeCustomerID,
                },
                true
            );
        }
        setDeleteModalState({ open: false, mediaId: null });
        onRefresh();
    };

    const handleDelete = (mediaId, isSignature = false) => {
        setDeleteModalState({ ...deleteModalState, open: true, mediaId: mediaId, isSignature: isSignature });
    };

    const renderMedia = () => {
        switch (open.type) {
            case 'signature':
                return (
                    <TransformWrapper>
                        {({ zoomIn, zoomOut, resetTransform }) => (
                            <React.Fragment>
                                <div className={classes.iconActions}>
                                    <Tooltip title="Zoom in">
                                        <IconButton className={classes.iconNavigation} onClick={zoomIn}>
                                            <ZoomInIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Zoom out">
                                        <IconButton className={classes.iconNavigation} onClick={zoomOut}>
                                            <ZoomOutIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Reset">
                                        <IconButton
                                            className={classes.iconNavigation}
                                            onClick={() => handleReset(resetTransform)}
                                        >
                                            <SettingsBackupRestore />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Rotate left">
                                        <IconButton className={classes.iconNavigation} onClick={() => rotateLeft()}>
                                            <RotateLeftIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Rotate right">
                                        <IconButton className={classes.iconNavigation} onClick={() => rotateRight()}>
                                            <RotateRightIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Download">
                                        <IconButton
                                            className={classes.iconNavigation}
                                            disabled={downloading[open.path]}
                                            onClick={() =>
                                                downloading[open.path] ? null : handleDownload(open.id, open.path, true)
                                            }
                                        >
                                            <CloudDownloadIcon />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <TransformComponent>
                                    <img
                                        style={rotationStyle(rotation)}
                                        className={classes.signature}
                                        src={open.path}
                                        alt="Signatures"
                                    />
                                </TransformComponent>
                            </React.Fragment>
                        )}
                    </TransformWrapper>
                );
            case 'image':
                return (
                    <TransformWrapper>
                        {({ zoomIn, zoomOut, resetTransform }) => (
                            <React.Fragment>
                                <div className={classes.iconActions}>
                                    <Tooltip title="Zoom in">
                                        <IconButton className={classes.iconNavigation} onClick={zoomIn}>
                                            <ZoomInIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Zoom out">
                                        <IconButton className={classes.iconNavigation} onClick={zoomOut}>
                                            <ZoomOutIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Reset">
                                        <IconButton
                                            className={classes.iconNavigation}
                                            onClick={() => handleReset(resetTransform)}
                                        >
                                            <SettingsBackupRestore />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Rotate left">
                                        <IconButton className={classes.iconNavigation} onClick={rotateLeft}>
                                            <RotateLeftIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Rotate right">
                                        <IconButton className={classes.iconNavigation} onClick={rotateRight}>
                                            <RotateRightIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Download">
                                        <IconButton
                                            className={classes.iconNavigation}
                                            disabled={downloading[open.path]}
                                            onClick={() => (downloading[open.path] ? null : handleDownload(open.id, open.path))}
                                        >
                                            <CloudDownloadIcon />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <TransformComponent>
                                    <div className={classes.paper}>
                                        <img
                                            style={rotationStyle(rotation)}
                                            className={classes.image}
                                            src={open.path}
                                            alt="Images"
                                        />
                                    </div>
                                </TransformComponent>
                            </React.Fragment>
                        )}
                    </TransformWrapper>
                );
            case 'audio':
                return ReactPlayer.canPlay(open.path) ? (
                    <div className={classes.audioItem}>
                        <Tooltip title="Download">
                            <IconButton
                                className={classes.iconActions}
                                disabled={downloading[open.path]}
                                onClick={() => (downloading[open.path] ? null : handleDownload(open.id, open.path))}
                            >
                                <CloudDownloadIcon />
                            </IconButton>
                        </Tooltip>
                        <ReactPlayer width="100%" playing controls url={open.path} />
                        <AudiotrackIcon color="primary" className={classes.audioIcon} />
                    </div>
                ) : (
                    <div className={classes.errorContainer}>
                        <div className={classes.iconErrorContainer}>
                            <ErrorOutlineIcon className={classes.iconError} />
                        </div>
                        <Typography className={classes.textError} variant="subtitle1" component="h2">
                            {translations['missing_media'] || `Missing media file`}
                        </Typography>
                    </div>
                );
            case 'video':
                return ReactPlayer.canPlay(open.path) ? (
                    <div>
                        <Tooltip title="Download">
                            <IconButton
                                className={classes.iconActions}
                                disabled={downloading[open.id]}
                                onClick={() => (downloading[open.id] ? null : handleDownload(open.id, open.path))}
                            >
                                <CloudDownloadIcon />
                            </IconButton>
                        </Tooltip>
                        <ReactPlayer width="100%" playing controls url={open.path} />
                    </div>
                ) : (
                    <div className={classes.errorContainer}>
                        <div className={classes.iconErrorContainer}>
                            <ErrorOutlineIcon className={classes.iconError} />
                        </div>
                        <Typography className={classes.textError} variant="subtitle1" component="h2">
                            {translations['missing_media'] || `Missing media file`}
                        </Typography>
                    </div>
                );
            default:
                return ReactPlayer.canPlay(open.path) ? (
                    <ReactPlayer width="100%" playing controls url={open.path} />
                ) : (
                    <div className={classes.errorContainer}>
                        <div className={classes.iconErrorContainer}>
                            <ErrorOutlineIcon className={classes.iconError} />
                        </div>
                        <Typography className={classes.textError} variant="subtitle1" component="h2">
                            {translations['missing_media'] || `Missing media file`}
                        </Typography>
                    </div>
                );
        }
    };

    const uploadPhotosBtn = (
        <Fab
            id="upload_photos"
            variant="extended"
            size="small"
            color="primary"
            aria-label="Upload photos"
            className={classes.fab}
            style={{ borderRadius: '1px' }}
            onClick={goToUploadMedia}
        >
            <CloudUpload fontSize="small" className={classes.iconUpload} />
            {translations['upload_photos'] || 'Upload photos'}
        </Fab>
    );

    return (
        <>
            {sortedSignatures &&
            sortedSignatures.length < 1 &&
            sortedImages &&
            sortedImages.length < 1 &&
            sortedVideos &&
            sortedVideos.length < 1 &&
            sortedAudio &&
            sortedAudio.length < 1 ? (
                <>
                    <Paper className={classes.root}>
                        <Grid key={'1'} item xs={12}>
                            <div className={classes.paper}>
                                <Typography variant="subtitle1" component="h2">
                                    {translations['this'] || `This`} {entity}{' '}
                                    {translations['not_media_for'] || `doesn't have media yet`}
                                </Typography>
                            </div>
                        </Grid>
                    </Paper>
                    {uploadPhotosBtn}
                </>
            ) : (
                <>
                    {!refresh ? (
                        <Paper className={classes.root}>
                            {uploadPhotosBtn}
                            {sortedSignatures && sortedSignatures.length > 0 ? (
                                <div>
                                    <Typography className={classes.mediaTitle} variant="h5">
                                        Signatures
                                    </Typography>
                                    <Grid className={classes.gridContainer} container spacing={3}>
                                        {sortedSignatures.map((signature, index) => {
                                            return (
                                                <Grid key={signature.id} item xs={6} sm={3}>
                                                    <Card>
                                                        <MediaItem
                                                            handleDelete={handleDelete}
                                                            handleOpen={handleOpen}
                                                            id={signature.id}
                                                            type={signature.type}
                                                            path={signature.path}
                                                            index={index}
                                                            createdAt={signature.createdAt}
                                                        />
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </div>
                            ) : null}
                            {sortedImages && sortedImages.length > 0 ? (
                                <div>
                                    <Typography className={classes.mediaTitle} variant="h5">
                                        Images
                                    </Typography>
                                    <Grid className={classes.gridContainer} container spacing={3}>
                                        {sortedImages.map((image, index) => {
                                            return (
                                                <Grid key={image.id} item xs={6} sm={3}>
                                                    <Card>
                                                        <MediaItem
                                                            handleDelete={handleDelete}
                                                            handleOpen={handleOpen}
                                                            id={image.id}
                                                            type={image.type}
                                                            path={image.path}
                                                            index={index}
                                                            createdAt={image.createdAt}
                                                        />
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </div>
                            ) : null}
                            {sortedVideos && sortedVideos.length > 0 ? (
                                <div>
                                    <Typography className={classes.mediaTitle} variant="h5">
                                        Videos
                                    </Typography>
                                    <Grid className={classes.gridContainer} container spacing={3}>
                                        {sortedVideos.map((file, index) => {
                                            return (
                                                <Grid key={file.id} item xs={6} sm={3}>
                                                    <Card>
                                                        <MediaItem
                                                            handleDelete={handleDelete}
                                                            handleOpen={handleOpen}
                                                            id={file.id}
                                                            type={file.type}
                                                            path={file.path}
                                                            index={index}
                                                            createdAt={file.createdAt}
                                                        />
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </div>
                            ) : null}
                            {sortedAudio && sortedAudio.length > 0 ? (
                                <div>
                                    <Typography className={classes.mediaTitle} variant="h5">
                                        Audio
                                    </Typography>
                                    <Grid className={classes.gridContainer} container spacing={3}>
                                        {sortedAudio.map((file, index) => {
                                            return (
                                                <Grid key={file.id} item xs={6} sm={3}>
                                                    <Card>
                                                        <MediaItem
                                                            handleDelete={handleDelete}
                                                            handleOpen={handleOpen}
                                                            id={file.id}
                                                            type={file.type}
                                                            path={file.path}
                                                            index={index}
                                                            createdAt={file.createdAt}
                                                        />
                                                    </Card>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </div>
                            ) : null}
                            <Modal className={classes.modal} open={open.open} onClose={handleClose}>
                                <div className={classes.modalDiv} onKeyDown={handleKeyPress}>
                                    <Tooltip title="Close">
                                        <IconButton className={classes.iconClose} onClick={handleClose}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <IconButton className={classes.iconNavigation} component="div" onClick={handleBack}>
                                        <ArrowBack fontSize="large" />
                                    </IconButton>
                                    <div className={classes.modalInner}>{renderMedia()}</div>
                                    <IconButton className={classes.iconNavigation} component="div" onClick={handleNext}>
                                        <ArrowForward fontSize="large" />
                                    </IconButton>
                                </div>
                            </Modal>
                            <MediaDelete
                                entityName={translations['media'] || 'Media'}
                                handleCloseDanger={handleCloseDanger}
                                handleCloseSafe={handleCloseSafe}
                                deleteModalState={deleteModalState}
                                deleting={deleting}
                            />
                        </Paper>
                    ) : null}
                </>
            )}
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        deleting: state.media.media.deleting,
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onDownload: (mediaId, isSignature) => dispatch(actionsDownload.downloadMedia(mediaId, isSignature)),
        onDeleteMedia: (data, isSignature) => dispatch(actions.deleteMedia(data, isSignature)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MediaGallery));
